import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import VirtualAgentBrowseConversationsQuery from '@atlassian/jira-relay/src/__generated__/VirtualAgentBrowseConversationsQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const DEFAULT_RANGE_DAYS = 14;

export const browseConversationsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-virtual-agent-browse-conversations" */ './src/VirtualAgentBrowseConversations.tsx'
			),
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const end = new Date();
		const start = new Date(end);
		start.setDate(start.getDate() - DEFAULT_RANGE_DAYS);

		return {
			extraProps: {
				initialDateRange: {
					start,
					end,
				},
			},
			queries: {
				page: {
					parameters: VirtualAgentBrowseConversationsQuery,
					variables: {
						cloudId: tenantContext.cloudId,
						projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
						startDate: start.toISOString(),
						endDate: end.toISOString(),
					},
				},
			},
		};
	},
});
